import React from 'react'
import PropTypes from 'prop-types'
import getImageSource from '../../services/mycharity/media/getImageSource'
import { withHandlers } from 'recompose'
import Label from '../texts/label'
import InputFile from '../forms/input-file'
import List from '../utilities/list'
import UploadImgItem from '../lists/upload-img-item'

const decorate = withHandlers({
  onClick: props => e => {
    e.preventDefault()
    e.stopPropagation()
    props.onDeleteClick(props.id)
  }
})

const UploadImgItemWithDelete = decorate(UploadImgItem)

const ImageGallery = props => {
  const ImgItems = props.images.map(({ id, thumb, source, description }) => (
    <UploadImgItemWithDelete
      key={id}
      id={id}
      src={getImageSource(thumb) || getImageSource(source)}
      filename={description}
      alt={description}
      onDeleteClick={props.onDeleteMedia}
    />
  ))
  return (
    <div>
      <Label shyLabel>{props.label}</Label>
      {props.isUploadVisible && (
        <InputFile
          iconName='image'
          helperText='Upload / Take picture'
          hasError={props.hasError}
          errorText={props.errorText}
          onChange={props.onFileUploadChange}
          value={props.file}
        />
      )}
      <List className='upload-img-list'>{ImgItems}</List>
    </div>
  )
}

ImageGallery.propTypes = {
  label: PropTypes.string,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      source: PropTypes.string,
      description: PropTypes.string,
      type: PropTypes.oneOf(['image', 'video'])
    })
  ),
  itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isUploadVisible: PropTypes.bool,
  file: PropTypes.string,
  hasError: PropTypes.bool,
  errorText: PropTypes.string,
  onFileUploadChange: PropTypes.func.isRequired,
  onDeleteMedia: PropTypes.func.isRequired
}

ImageGallery.defaultProps = {
  label: 'Images',
  images: [],
  isUploadVisible: true
}

export default ImageGallery



// WEBPACK FOOTER //
// ./src/ui/forms/image-gallery.js